exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item[data-v-5943ccb4] {\n  border: solid 1px #ccc;\n  border-radius: 3px;\n  margin: .5rem;\n  padding: 1rem 1.5rem;\n  clear: both;\n  background: white;\n}\n.item .key[data-v-5943ccb4] {\n  background: #839aaf;\n  border-radius: 2px;\n  padding: .5rem;\n  color: white;\n  font-family: monospace;\n  font-weight: 500;\n  display: inline-block;\n  font-size: 12px;\n}\n", ""]);

// exports
